export default __webpack_public_path__ + "static/media/em_hat_1.a08ffe1a.jpg";